module.exports = __webpack_public_path__ + "img/1F60D.9bbcd2e6.svg";